import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "emailField", "emailInput", "frequency", "weeklyField", "monthlyField", "sftpNote"
  ]

  connect() {
    this.toggle()
    this.toggleScheduleFields()
  }

  toggle() {
    const delivery = this.element.querySelector("input[name='delivery_method']:checked")?.value
    const emailSelected = delivery === "email"

    if (this.hasEmailFieldTarget) {
      this.emailFieldTarget.classList.toggle("hidden", !emailSelected)
    }
    if (this.hasEmailInputTarget) {
      this.emailInputTarget.required = emailSelected
      if (!emailSelected) this.emailInputTarget.value = ""
    }
    if (this.hasSftpNoteTarget) {
      this.sftpNoteTarget.classList.toggle("hidden", delivery !== "sftp")
    }
  }

  toggleScheduleFields() {
    const frequency = this.hasFrequencyTarget ? this.frequencyTarget.value : "weekly"

    if (this.hasWeeklyFieldTarget) {
      this.weeklyFieldTarget.classList.toggle("hidden", frequency !== "weekly")
    }
    if (this.hasMonthlyFieldTarget) {
      this.monthlyFieldTarget.classList.toggle("hidden", frequency !== "monthly")
    }
  }
}
